//Campaigns
export const CAMPAIGNS = '/affiliate-marketing';

export const CAMPAIGNS_LIST = CAMPAIGNS + '/affiliate-campaigns';
export const CAMPAIGNS_BANNERS = CAMPAIGNS + '/banners';
export const CAMPAIGNS_SMARTLINKS = CAMPAIGNS + '/smartlinks';
export const CAMPAIGNS_LANDING_PAGES = CAMPAIGNS + '/landing-pages';
export const CAMPAIGNS_YOUR_CONFIGURATIONS = CAMPAIGNS + '/your-campaigns';
export const CAMPAIGNS_PROMOTION_CODES = CAMPAIGNS + '/promotion-codes';

//Content Lockers
export const CONTENT_LOCKER = '/tools/content-lockers';

export const CONTENT_LOCKER_CPA_LOCKER = CONTENT_LOCKER + '/cpa-locker';
export const CONTENT_LOCKER_CAPTCHA_LOCKER = CONTENT_LOCKER + '/captcha-locker';
export const CONTENT_LOCKER_FILE_LOCKER = CONTENT_LOCKER + '/file-locker';
export const CONTENT_LOCKER_MOBILE_REWARDS = CONTENT_LOCKER + '/mobile-rewards';
export const CONTENT_LOCKER_AVAILABLE_CAMPAIGNS = CONTENT_LOCKER + '/incent-campaigns';
export const CONTENT_LOCKER_OFFER_API = CONTENT_LOCKER + '/offer-api';

//OfferWall rewards
export const OFFER_WALL_REWARDS = '/tools/offerwall-rewards';
